export const getCurrentViewport = () => {
  let breakpoint: any = {};
  breakpoint.refreshValue = function () {
    this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
  };
  breakpoint.refreshValue();
  return breakpoint.value;
}

function getCurrentIndex() {
  return getIndex(getCurrentViewport());
}

function getIndex(viewport) {
  return [
    'breakpoint--480px', 
    'breakpoint--768px', 
    'breakpoint--1024px', 
    'breakpoint--1440px', 
    'breakpoint--1920px',
  ].indexOf(viewport);
}

export const breakpointUp = (viewport) => {
  return getIndex(viewport) < (getCurrentIndex() + 1);
}

export const breakpointDown = (viewport) => {
  return getIndex(viewport) > getCurrentIndex();
}

// taken from underscore.js
export function debounce(func, wait, immediate) {
  let timeout = null;
  return function () {
    const context = this, args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// https://gist.github.com/beaucharman/e46b8e4d03ef30480d7f4db5a78498ca
export function throttle(callback, wait, immediate = false) {
  let timeout = null
  let initialCall = true

  return function () {
    const callNow = immediate && initialCall
    const next = function () {
      callback.apply(this, arguments)
      timeout = null
    }

    if (callNow) {
      initialCall = false
      next()
    }

    if (!timeout) {
      timeout = setTimeout(next, wait)
    }
  }
}

export const clickoutside = (element:any, callback) => {
  document.body.addEventListener('click', (evt) => {
    let targetElement: any = evt.target;
    do {
      if (targetElement === element) {
        return;
      }
      targetElement = targetElement.parentNode;
    } while (targetElement);

    callback();
  });
}